export enum TrainingCourseState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Expired = 'EXPIRED',
};
